import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';

class CityNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    // 城市数据（增加配置：是否在第一行）
    // cityList = [
    //     { name: '乌鲁木齐市', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306192-', isFirstRow: true },
    //     { name: '伊犁哈萨克自治州', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306193-', isFirstRow: true },
    //     { name: '塔城地区', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306194-', isFirstRow: true },
    //     { name: '阿勒泰地区', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306195-', isFirstRow: true },
    //     { name: '克拉玛依市', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306196-', isFirstRow: true },
    //     { name: '博尔塔拉蒙古自治州', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306197-', isFirstRow: true },
    //     { name: '昌吉回族自治州', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306198-', isFirstRow: true },
    //     { name: '哈密市', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306199-', isFirstRow: true },
    //     { name: '吐鲁番市', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306200-', isFirstRow: true },
    //     { name: '巴音郭楞蒙古自治州', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306201-', isFirstRow: false },
    //     { name: '阿克苏地区', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306202-', isFirstRow: false },
    //     { name: '克孜勒苏柯尔克孜自治州', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306203-', isFirstRow: false },
    //     { name: '喀什地区', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306204-', isFirstRow: false },
    //     { name: '和田地区', url: 'https://xj.ifeng.com/shanklist/200-306129-306189-306205-', isFirstRow: false },
    // ];

    // 渲染城市导航
    cityView(list = []) {
        const cities = list.length > 0 ? list : this.cityList;

        return cities.map((item, index) => (
            <li key={index}>
                <a href={item.url} target="_blank">
                    {item.name}
                </a>
            </li>
        ));
    }

    cityNavRender = () => {
        const { content } = this.props;
        const cities = content;

        // 若数据中带有 isFirstRow 配置，则按配置拆分；否则回退为按索引拆分
        let firstRow = [];
        let secondRow = [];

        if (cities.some(item => Object.prototype.hasOwnProperty.call(item, 'isFirstRow'))) {
            firstRow = cities.filter(item => item.isFirstRow);
            secondRow = cities.filter(item => !item.isFirstRow);
        } else {
            // 回退逻辑：默认前 9 个为第一行
            firstRow = cities.slice(0, 9);
            secondRow = cities.slice(9);
        }

        return (
            <div
                className={`${styles.city_nav_box} city_nav_box`}
                id="cityNavigation"
            >
                <ul className={`${styles.city_nav} clearfix city_nav`}>
                    {this.cityView(firstRow)}
                </ul>
                {secondRow.length > 0 && (
                    <>
                        <div className={styles.city_nav_split} />
                        <ul className={`${styles.city_nav} clearfix city_nav`}>
                            {this.cityView(secondRow)}
                        </ul>
                    </>
                )}
            </div>
        );
    };

    render() {
        return (

            <Chip id="261117" type="struct" title="地州市导航" groupName="顶部">
                {this.cityNavRender()}
            </Chip>
        );
    }
}

export default CityNav;
